var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccassions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 15.625,
    height: 20,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6513 5.92116V2H9.19873V5.92116",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19873 12.4014V22.0002H11.6513V12.4014",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6982 9.32752H19.6251V6.83789H14.0707",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30128 9.32752H4V6.83789H6.50955",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.374 6.83862C10.1928 6.12223 9.5524 5.59277 8.79018 5.59277H6.45215V6.42265C6.45215 7.33929 7.1842 8.0824 8.0872 8.0824H9.1951",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6479 8.0824H12.7636C13.6666 8.0824 14.3987 7.33929 14.3987 6.42265V5.59277H12.0606C11.2987 5.59277 10.6586 6.12174 10.4771 6.83759",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5948 8.38281C12.3593 8.80439 12.8784 9.62667 12.8784 10.5719V12.4007H10.4258V9.32721",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4216,
    cy: 8.0827,
    rx: 1.22629,
    ry: 1.24481,
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4262 9.32729V12.4008H7.97363V10.572C7.97363 9.63463 8.48397 8.81824 9.23801 8.39355",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccassions);
export default __webpack_public_path__ + "static/media/occassions.292e4fe1e20d07b70d31192a091224ee.svg";
export { ForwardRef as ReactComponent };